import { randomValueGenerator } from "@swa-ui/inflight";

export const getMockRouterDetailsForNonRIG = () => ({
  clientId: randomValueGenerator(48),
  routerId: "01000000000000000139E9BC",
  sandboxed: true,
  sandboxId: 7,
});
